import { Modal as AntModal } from 'antd'
import type { ComponentProps } from 'react'

type AntModalProps = ComponentProps<typeof AntModal>

export interface AppModalProps extends Omit<AntModalProps, 'visible'> {
  open?: boolean
}

export const AppModal = ({ open, ...rest }: AppModalProps) => <AntModal open={open} {...rest} />
